// extracted by css-extract-rspack-plugin
export default {"modal":"OqG5VV","content":"gQb1L4","header":"qRfmB7","heading":"OoNajQ","actions":"pBCcrL"};